import { render, staticRenderFns } from "./AddReferencePopup.vue?vue&type=template&id=13a83c70"
import script from "./AddReferencePopup.vue?vue&type=script&lang=js"
export * from "./AddReferencePopup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports